var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("n-dialog-header", {
        attrs: {
          isField: _vm.isField,
          isShowOtherTypes: _vm.isShowOtherTypes,
          from: "question",
          courseId: _vm.courseId,
          subjectId: _vm.subjectId,
          dialogVisible: _vm.dialogVisible,
          chooseNum: _vm.chooseNum
        },
        on: { searchFunc: _vm.searchFunc, changeCategory: _vm.changeCategory }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [
        _c(
          "div",
          { staticClass: "left_tree" },
          [
            _vm.courseModel == 2
              ? _c("catalog-tree", {
                  ref: "leftTree",
                  attrs: { subjectId: _vm.subjectId, height: "350px" },
                  on: { treeClick: _vm.treeClickSearch }
                })
              : _c("standard-product", {
                  ref: "leftTree",
                  attrs: { height: "350px" },
                  on: { showListStandard: _vm.showListStandard }
                })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "right_table" },
          [
            _c("n-table", {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              ref: "question_testArea",
              attrs: {
                tableData: _vm.tableData,
                tableHeader: _vm.QuestionDialogTableHeader,
                ISChangeCheckout: true,
                TableHeight: "320px",
                canExpand: true
              },
              on: { operation: _vm.operation }
            }),
            _vm._v(" "),
            _c("Pagination", {
              key: _vm.addQuestionKey,
              attrs: {
                currentpage: _vm.pageTotal.currentPage,
                limit: _vm.pageTotal.pageSize,
                total: _vm.pageTotal.total,
                "pager-count": 5,
                layout: "total, sizes, prev, pager, next, jumper",
                small: true
              },
              on: {
                handleCurrentChange: _vm.handleCurrentChange,
                handleSizeChange: _vm.handleSizeChange
              }
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-64bbed62", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64bbed62","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/szrt_revision/new_course_module/editCourse/question/addQuestion.vue
// module id = null
// module chunks = 